import { Fragment, useRef, useEffect } from 'react';
import { useFormikContext } from 'formik';
import BN from 'bn.js';

import DropdownTokensField from '../../fields/dropdown-tokens-field';
import RetireTable from 'components/retire-table/retire-table';
import { Button } from 'components/common/button/button';
import { Input } from 'components/common/form/input';
import { getFieldProps, getFontSize } from 'utils';
import { parseTokenAmount } from 'utils/amounts';
import { FormValues } from 'types';

import FungibleTokens from 'services/fungible-tokens';
const { getFormattedTokenAmount } = FungibleTokens;

import { useAppSelector } from 'redux/use-hooks';
import { selectActiveToken } from 'redux/slices/tokens';
import useSelectedProjects from 'lib/hooks/use-selected-projects';
import useProjectsSearch from 'lib/hooks/use-projects-search';

import {
  StyledButtonWrapper,
  StyledInputLabel,
  StyledInputMount,
  StyledInputValue,
  StyledInputWrapper
} from '../../send-view.style';

const SendView = () => {
  const inputEl = useRef<HTMLInputElement>();
  const activeToken = useAppSelector(selectActiveToken);
  const formik = useFormikContext<FormValues>();
  const { values, setFieldValue, errors, setErrors } = formik;
  const { selected, sum, handleSelectOne, handleChangeOne } =
    useSelectedProjects();
  const { items, search, setSearch } = useProjectsSearch();
  useEffect(() => {
    if (values.token === 'OCC') {
      if (
        selected.some(
          (item) =>
            item.error !== '' || item.value === '' || Number(item.value) === 0
        )
      ) {
        setErrors({
          ...errors,
          amount: 'Value empty or value equal zero'
        });
      }
    }
  }, [values.token, errors, selected]);

  useEffect(() => {
    if (values.token === 'OCC') {
      if (selected.length > 0) {
        setFieldValue(
          'selected',
          selected.map((item) => {
            return [
            item.project_id,
            item.value && item.value !== '.' && item.value !== ''
              ? parseTokenAmount(item.value)
              : '0'
          ]})
        );
      }
    }
  }, [values.token, selected]);

  useEffect(() => {
    if (values.token === 'OCC') {
      setFieldValue('amount', sum.replace(/,/g, ''));
    }
  }, [values.token, sum]);
  return (
    <Fragment>
      <StyledInputMount
        required
        autoFocus
        ref={inputEl}
        style={{
          fontSize: `${
            values.amount.length ? getFontSize(values.amount.length) : 64
          }px`
        }}
        disabled={values.token === 'OCC'}
        {...getFieldProps(formik, 'amount')}
      />
      {values.token !== 'OCC' && (
        <StyledButtonWrapper>
          <Button
            type="button"
            variant="secondary"
            size="small"
            onClick={() => {
              const formattedTokenAmount = getFormattedTokenAmount(
                activeToken.balance,
                  activeToken.onChainFTMetadata.symbol,
              activeToken.onChainFTMetadata.decimals
              );
              if (!new BN(activeToken.balance).isZero()) {
                setFieldValue('amount', formattedTokenAmount.replace(/,/g, ''));
              }
            }}
          >
            Use Max
          </Button>
        </StyledButtonWrapper>
      )}

      <DropdownTokensField inputElement={inputEl} />

      {values.token === 'OCC' && (
        <>
          <Input
            variant="search"
            type="text"
            name="search"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            placeholder="Search for the name of a project"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
          <RetireTable
            mode="input"
            data={items}
            selected={selected}
            handleChange={handleChangeOne}
            handleSelect={handleSelectOne}
            mb="20px"
          />
        </>
      )}
      <StyledInputWrapper mb={values.token === 'OCC' ? '20px' : '48px'}>
        <StyledInputLabel>Available to Send</StyledInputLabel>
        <StyledInputValue>
          {getFormattedTokenAmount(
            activeToken.balance,
              activeToken.onChainFTMetadata.symbol,
            activeToken.onChainFTMetadata.decimals
          )}
        </StyledInputValue>
      </StyledInputWrapper>
    </Fragment>
  );
};

export default SendView;
